import { FC, memo } from 'react';

import GenericLayout from '../../../components/generic-layout/GenericLayout';
import Grid2 from '../../../components/grid/Grid2';
import { H2, H3 } from '../../../components/heading/Hx';
import List from '../../../components/list/List';
import ListItem from '../../../components/list/ListItem';
import Paragraph from '../../../components/paragraph/Paragraph';
import Route from '../../../components/route/Route';
import Section from '../../../components/section/Section';
import Video from '../../../components/video/Video';
import { COLOR } from '../../../theme/type';
import { CV } from './cv';
import PageImageAS from './PageImageAS';
import { PROSA } from './prosa';

const AlexanderSolovev: FC = () => (
  <GenericLayout title='Alexander Solovev'>
    <PageImageAS />

    <Section background={COLOR.Dark3}>
      <H2 color={COLOR.Gold1}>Alexander Solovev</H2>

      <Video src={'310949077'} sx={{ display: { md: 'none' } }}></Video>

      <Grid2 spacing={{ md: '2rem', xs: '1.5rem' }}>
        <Grid2.Item>
          <H3>Lebenslauf</H3>
          <List bullets itemProps={{ margin: '0' }}>
            {CV.map(text => (
              <ListItem key={text}>{text}</ListItem>
            ))}
          </List>
        </Grid2.Item>
        <Grid2.Item>
          <H3>Kampfkunst</H3>
          <List bullets itemProps={{ margin: '0' }}>
            {PROSA.map((item, index) => (
              <ListItem key={index}>{item}</ListItem>
            ))}
          </List>
        </Grid2.Item>
      </Grid2>

      <Video src={'310949077'} sx={{ display: { md: 'block', xs: 'none' } }} />

      <Paragraph margin={{ top: '3rem' }}>
        Weitere Informationen zu Alexander Solovev finden sich auf seiner Website:
        <br />
        <Route href='https://solovevstyle.ab.ru/'>solovevstyle.ab.ru</Route>
      </Paragraph>
    </Section>
  </GenericLayout>
);

export default memo(AlexanderSolovev);
